import styled, { css } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

const TRIGGER_MIN_HEIGHT_PX = 56;

export const StyledCategoryTrigger = styled(Flex)<{ $isOpen: boolean; $isDisabled: boolean }>`
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    min-height: ${TRIGGER_MIN_HEIGHT_PX}px;
    padding: 12px;
    border: 1px solid ${colorsPalettes.carbon[50]};
    border-radius: 6px;
    background: ${({ $isOpen }) => ($isOpen ? colorsPalettes.carbon[0] : colorsPalettes.carbon[25])};
    ${setFontVariant("subtitle1", colorsPalettes.carbon[400])}

    ${({ $isDisabled }) =>
        $isDisabled
            ? css`
                  cursor: default;
                  color: ${colorsPalettes.carbon[200]};
              `
            : css`
                  cursor: pointer;
              `}
`;

export const StyledTriggerValue = styled(Flex)`
    white-space: nowrap;
    ${setFontVariant("body2", colorsPalettes.carbon[300])}
`;
